import { Box, Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface PageTitleProps {
  title: string;
  subTitle?: string;
  width?: string;
  position?: "fixed" | "absolute";
  padding?: string | number;
  children: ReactNode;
}

export const PageTitle = ({
    title,
    subTitle,
    width,
    position = "fixed",
    padding,
    children,
}: PageTitleProps) => {
    return (
        <Box
            sx={(theme) => ({
                position,
                width: position === "fixed" ? "calc(100% - 192px)" : "100%",
                left: position === "fixed" ? "192px" : "0",
                marginTop: "48px",
                padding: padding ?? "24px",
                zIndex: 99,
                backgroundColor: theme.palette.background.default,
            })}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width={width}
            >
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "text.primary", overflow: "hidden", whiteSpace: "nowrap" }}
                >
                    {title}
                </Typography>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    {children}
                </Box>
                {!!subTitle &&
                    <Typography
                        variant="subtitle2"
                        title={subTitle}
                        sx={{ color: "text.secondary", position: "absolute", left: "24px", bottom: "1px", width: "calc(100% - 48px)", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                    >
                        {subTitle}
                    </Typography>
                }
            </Box>
        </Box>
    );
};
